//@ts-nocheck
import React, { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

export const CountUpStats = () => {
  return (
    <div className="mx-auto max-w-4xl px-4 py-20 md:py-20">
      <h2 className="mb-8 text-center text-base text-indigo-900 sm:text-lg md:mb-16">
        FUTEUR AI's <span className="text-indigo-500">Bold Mission for 2029</span>
      </h2>

      <div className="flex flex-col items-center justify-center sm:flex-row">
        <Stat
          num={105}
          suffix="M"
          subheading="Jobs by 2029"
        />
        <div className="h-[1px] w-12 bg-black-200 sm:h-12 sm:w-[1px]" />
        <Stat
          num={60}
         
          suffix="M"
          subheading="Thriving SMEs"
        />
        <div className="h-[1px] w-12 bg-indigo-200 sm:h-12 sm:w-[1px]" />
        <Stat
          num={1}
          prefix="$"
          suffix="T"
          subheading="Economic Growth"
        />
      </div>
    </div>
  );
};

const Stat = ({ num, prefix = "", suffix = "", decimals = 0, subheading }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;

    animate(0, num, {
      duration: 2.5,
      onUpdate(value) {
        if (!ref.current) return;

        ref.current.textContent = `${prefix}${value.toFixed(decimals)}${suffix}`;
      },
    });
  }, [num, decimals, isInView, prefix, suffix]);

  return (
    <div className="flex w-72 flex-col items-center py-8 sm:py-0">
      <p className="mb-2 text-center text-6xl font-semibold text-black sm:text-5xl">
        <span ref={ref}></span>
      </p>
      <p className="max-w-48 text-center text-neutral-600 font-medium">{subheading}</p>
    </div>
  );
};

